module.exports = __webpack_public_path__ + "static/story6-hero-1920x1080-f41a9b26a5468f60f90594e09600782f.jpg";